import { ModalRef, SprintDayCardData } from 'constants/WorkingModePathwaysConstants'

import { PathwayAgendaDetailButtons } from './PathwayAgendaDetailButtons'
import { renderSegments } from './renderSegments'

interface SprintDayCardProps {
  card: SprintDayCardData
  onOpenModal: (ref: ModalRef) => void
}

export const SprintDayCard = ({ card, onOpenModal }: SprintDayCardProps) => (
  <div className="insights-resource-card pathway-day-card">
    <p className="title-xxs relative w-full">
      {card.dayLabel}
      {card.title ? `: ${card.title}` : ''}
      {card.optionalBadge && <span className="pathway-optional-badge absolute right-[-70px] body-xs">(Optional)</span>}
    </p>
    <p className="body-s w-full">{renderSegments(card.segments)}</p>
    {card.actions && <PathwayAgendaDetailButtons actions={card.actions} onOpen={onOpenModal} />}
    <span className={card.number === 1 ? 'insights-resource-card-number-one' : 'insights-resource-card-number'}>
      {card.number}
    </span>
  </div>
)
